// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-cms-text-image',
    // #endregion
    // #region Properties
    props: {
        content: {
            type: Object,
            required: true,
            default: {}
        },
    },
    computed: {
        getSlots() {
            return this.content.slots || [];
        },
        getLeftContent() {
            return this.getSlots.find(({ slot }) => slot === "left");
        },
        getRightContent() {
            return this.getSlots.find(({ slot }) => slot === "right");
        },
    }
    // #endregion
});
// #endregion
